import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ChipsFilter from '@components/commonFilters/ChipsFilter';

import { setFilters } from '@store/common/action';
import { getAllTags, getCommonFilters } from '@store/reducers';
import { fetchAllTags } from '@store/supplier/action';

const FabricSpec = ({ type = 'FILTER', onSelectCallBack, isClearAll, onResetClearValue }) => {
	const [, setSelectedItem] = useState(null);
	const [isUpdated, setIsUpdated] = useState(true);
	const dispatch = useDispatch();
	const tagType = 'MATERIAL_SUSTAINABLE_TAG';
	let allTags = useSelector(getAllTags);
	allTags = allTags?.materialTags?.map((item) => {
		return {
			id: item.id,
			text: item.text,
			value: item.id,
			label: item.text
		};
	});
	const commonfilters = useSelector(getCommonFilters);

	useEffect(() => {
		dispatch(fetchAllTags('', tagType));
	}, []);

	useEffect(() => {
		if (isClearAll) {
			setSelectedItem(null);
			setIsUpdated(false);
			setTimeout(() => {
				setIsUpdated(true);
			}, 0);
		}
	}, [isClearAll]);

	const onSelectFabric = (value) => {
		setSelectedItem(value);

		let items = value.map((item) => {
			if (item?.__isNew__) {
				return {
					id: null,
					text: item.value
				};
			} else {
				return {
					id: item.id,
					text: item.text
				};
			}
		});

		if (type === 'FILTER') {
			onResetClearValue(false);
			dispatch(
				setFilters({
					...commonfilters,
					tagIdList: items.map((item) => item.id)
				})
			);
		} else {
			onSelectCallBack(items);
		}
	};

	return (
		<div>
			{isUpdated && (
				<ChipsFilter
					type={type === 'FILTER' ? '' : 'CREATABLE'}
					allItems={allTags}
					title={'Fabric spec'}
					onSetSelectedItem={(value) => onSelectFabric(value)}
				/>
			)}
		</div>
	);
};

export default FabricSpec;
